export default {
  buttons: {
    next: "下一步",
    prev: "上一步",
    skip: "跳过",
    done: "完成",
    gotIt: "知道了",
  },
  messages: {
    dontShowAgainLabel: "不再显示",
    stepNumbersOfLabel: "/",
  },
};
